import { render } from "./DeaddropReceivePanel.vue?vue&type=template&id=5b74322f&scoped=true"
import script from "./DeaddropReceivePanel.vue?vue&type=script&lang=js"
export * from "./DeaddropReceivePanel.vue?vue&type=script&lang=js"

import "./DeaddropReceivePanel.vue?vue&type=style&index=0&id=5b74322f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b74322f"]])

export default __exports__